<template>
    <b-card no-body>
        <!-- Statistics Cards -->
        <div class="px-2 pt-2 pb-1">
            <!-- Genel Özet -->
            <div class="row match-height mb-1">
                <div class="col mb-1">
                    <v-stats-box icon="receipt_long" :value="statistics.TotalTransferCount" text="Toplam Transfer" variant="primary" />
                </div>
                <div class="col mb-1">
                    <v-stats-box icon="sync_alt" variant="success" :value="statistics.VehicleToVehicleCount" text="Araçtan Araca Adet" />
                </div>
                <div class="col mb-1">
                    <v-stats-box icon="local_gas_station" variant="success" :value="(statistics.VehicleToVehicleTotalQuantityStr || '0,00') + ' lt'" text="Araçtan Araca Miktar" />
                </div>
                <div class="col mb-1">
                    <v-stats-box icon="warehouse" variant="info" :value="statistics.VehicleToStorageCount" text="Araçtan Depoya Adet" />
                </div>
                <div class="col mb-1">
                    <v-stats-box icon="local_gas_station" variant="info" :value="(statistics.VehicleToStorageTotalQuantityStr || '0,00') + ' lt'" text="Araçtan Depoya Miktar" />
                </div>
            </div>

            <!-- Yakıt Tipi Bazlı Satırlar -->
            <div v-for="ft in statistics.FuelTypeBreakdown" :key="ft.FuelTypeId" class="row match-height mb-1">
                <div class="col mb-1">
                    <v-stats-box icon="receipt_long" variant="secondary" :value="ft.Count" :text="ft.FuelTypeName + ' Toplam'" />
                </div>
                <div class="col mb-1">
                    <v-stats-box icon="sync_alt" variant="secondary" :value="ft.VehicleToVehicleCount" :text="ft.FuelTypeName + ' A→A Adet'" />
                </div>
                <div class="col mb-1">
                    <v-stats-box icon="local_gas_station" variant="secondary" :value="(ft.VehicleToVehicleQuantityStr || '0,00') + ' lt'" :text="ft.FuelTypeName + ' A→A Miktar'" />
                </div>
                <div class="col mb-1">
                    <v-stats-box icon="warehouse" variant="secondary" :value="ft.VehicleToStorageCount" :text="ft.FuelTypeName + ' A→D Adet'" />
                </div>
                <div class="col mb-1">
                    <v-stats-box icon="local_gas_station" variant="secondary" :value="(ft.VehicleToStorageQuantityStr || '0,00') + ' lt'" :text="ft.FuelTypeName + ' A→D Miktar'" />
                </div>
            </div>
        </div>



        <!-- Filters -->
         <b-card-body>
            <div class="row">
                 <div class="col-12 col-md-2 mb-1">
                    <v-date-picker v-model="filter.StartDate" placeholder="Başlangıç Tarihi" class="w-100" />
                </div>
                 <div class="col-12 col-md-2 mb-1">
                    <v-date-picker v-model="filter.EndDate" placeholder="Bitiş Tarihi" class="w-100" />
                </div>
                <div class="col-12 col-md-2 mb-1">
                     <v-select-list
                        v-model="filter.TransferType"
                        :options="transferTypes"
                        label="text"
                        :reduce="(option) => option.value"
                        placeholder="Tüm Transfer Tipleri"
                    />
                </div>
                 <div class="col-12 col-md-3 mb-1">
                     <v-select-list
                        v-model="filter.FromVehiclePlateId"
                        :options="vehiclePlates"
                        label="PlateValue"
                        :reduce="(option) => option.Id"
                        placeholder="Tüm Kaynak Araçlar"
                    />
                </div>
                <div class="col-12 col-md-3 col-lg-1 mb-1">
                     <b-button variant="primary" @click="refreshData" class="w-100">Ara</b-button>
                </div>
                <div class="col-12 col-md-3 col-lg-1 mb-1">
                     <b-button variant="outline-secondary" @click="clearFilter" class="w-100">Temizle</b-button>
                </div>
            </div>
        </b-card-body>
        
        <!-- Table -->
        <div class="px-2">
            <v-table
                ref="table"
                :add-callback="createNew"
                :fields="fields"
                name="transfer-fuel"
                :buttons="buttons"
                pagination="server"
                :items-provider="provider"
                :filter="filter" 
            >
                <template #cell(IsFromVehicleToVehicle)="data">
                     <span v-if="data.item.IsFromVehicleToVehicle" class="badge badge-light-success">Araçtan Araca</span>
                     <span v-else class="badge badge-light-info">Araçtan Depoya</span>
                </template>
            </v-table>
        </div>

        <!-- Kayıt / Düzenleme Modalı -->
         <b-modal id="create-transfer-fuel" :title="editing ? 'Transfer Düzenle' : 'Yeni Transfer'" no-close-on-esc no-close-on-backdrop size="lg">
            <transfer-fuel-modal v-model="form" :errors="errors" :editing="editing" />
            <template #modal-footer>
                 <v-executer :loading="loading" :editing="editing" :action="save" :disabled="false"></v-executer>
            </template>
        </b-modal>

        <!-- Detay Modalı -->
        <b-modal id="view-transfer-detail" title="Transfer Detayı" size="lg" ok-only ok-title="Kapat" ok-variant="secondary">
            <div v-if="selectedItem" class="row">
                <div class="col-12 mb-1">
                    <h6 class="text-muted mb-50">Genel Bilgiler</h6>
                    <table class="table table-sm table-bordered">
                        <tbody>
                            <tr><th class="w-40">İşlem No</th><td>{{ selectedItem.ProcessCode }}</td></tr>
                            <tr><th>Tarih/Saat</th><td>{{ selectedItem.ProcessDateStr }}</td></tr>
                            <tr><th>Transfer Tipi</th><td>{{ selectedItem.TransferType }}</td></tr>
                            <tr><th>Yakıt Tipi</th><td>{{ selectedItem.FuelType }}</td></tr>
                            <tr><th>Miktar</th><td>{{ selectedItem.QuantityStr }} Lt</td></tr>
                            <tr><th>Personel</th><td>{{ selectedItem.ResponsiblePerson }}</td></tr>
                            <tr><th>Açıklama</th><td>{{ selectedItem.Description || '—' }}</td></tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-md-6 mb-1">
                    <h6 class="text-muted mb-50">Kaynak Araç</h6>
                    <table class="table table-sm table-bordered">
                        <tbody>
                            <tr><th class="w-40">Plaka</th><td>{{ selectedItem.FromVehiclePlate || '—' }}</td></tr>
                            <tr><th>KM</th><td>{{ selectedItem.FromVehicleCurrentKM != null ? selectedItem.FromVehicleCurrentKM.toLocaleString('tr-TR') + ' km' : '—' }}</td></tr>
                            <tr><th>Sürücü</th><td>{{ selectedItem.FromVehicleDriverName || '—' }}</td></tr>
                            <tr v-if="selectedItem.FromVehicleSeyirDriverFullName && selectedItem.FromVehicleSeyirDriverFullName !== selectedItem.FromVehicleDriverName">
                                <th>Seyir Sürücüsü</th><td>{{ selectedItem.FromVehicleSeyirDriverFullName }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-md-6 mb-1">
                    <h6 class="text-muted mb-50">Hedef</h6>
                    <table class="table table-sm table-bordered">
                        <tbody>
                            <tr><th class="w-40">{{ selectedItem.TransferType === 'Araçtan Araca' ? 'Plaka' : 'Depo' }}</th><td>{{ selectedItem.TargetName || '—' }}</td></tr>
                            <tr v-if="selectedItem.TransferType === 'Araçtan Araca'">
                                <th>KM</th><td>{{ selectedItem.ToVehicleCurrentKM != null ? selectedItem.ToVehicleCurrentKM.toLocaleString('tr-TR') + ' km' : '—' }}</td>
                            </tr>
                            <tr v-if="selectedItem.TransferType === 'Araçtan Araca'">
                                <th>Sürücü</th><td>{{ selectedItem.ToVehicleDriverName || '—' }}</td>
                            </tr>
                            <tr v-if="selectedItem.TransferType === 'Araçtan Araca' && selectedItem.ToVehicleSeyirDriverFullName && selectedItem.ToVehicleSeyirDriverFullName !== selectedItem.ToVehicleDriverName">
                                <th>Seyir Sürücüsü</th><td>{{ selectedItem.ToVehicleSeyirDriverFullName }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-modal>

    </b-card>
</template>

<script>
import { BCard, BCardBody, BButton, BModal } from 'bootstrap-vue'
import VStatsBox from '@/components/VStatsBox.vue'
import api from "@/api/fuel-storage";
import systemDataApi from "@/api/system-data";
import TransferFuelModal from './components/TransferFuelModal.vue';

export default {
    components: {
        BCard, BCardBody, BButton, BModal,
        VStatsBox,
        TransferFuelModal
    },
    data() {
        return {
            loading: false,
            errors: {},
            editing: false,
            // Statistics objesi tüm string alanlarla başlatılmalı; aksi halde backend
            // çağrısı tamamlanmadan veya başarısız döndüğünde stats kutucuklarında
            // "undefined lt" / "Undefined lt" görüntüleniyor.
            statistics: {
                TotalTransferCount: 0,
                VehicleToVehicleCount: 0,
                VehicleToStorageCount: 0,
                VehicleToVehicleTotalQuantity: 0,
                VehicleToVehicleTotalQuantityStr: "0,00",
                VehicleToStorageTotalQuantity: 0,
                VehicleToStorageTotalQuantityStr: "0,00",
                TotalQuantity: 0,
                TotalQuantityStr: "0,00",
                FuelTypeBreakdown: []
            },
            filter: {
                StartDate: null,
                EndDate: null,
                TransferType: null,
                FromVehiclePlateId: null
            },
            transferTypes: [
                { value: 1, text: 'Araçtan Araca' },
                { value: 2, text: 'Araçtan Depoya' }
            ],
            vehiclePlates: [],
            selectedItem: null,
            form: {
                IsFromVehicleToVehicle: true,
                FuelTypeId: null,
                Quantity: 0,
                FromVehiclePlateId: null,
                ToVehiclePlateId: null,
                ToFuelStorageId: null,
                ResponsibleEmployeeId: null,
                Description: '',
                FromVehicleCurrentKM: null,
                FromVehicleDriverEmployeeId: null,
                FromVehicleSeyirDriverFullName: null,
                FromVehicleSeyirDriverId: null,
                FromVehicleSeyirDriverKey: null,
                ToVehicleCurrentKM: null,
                ToVehicleDriverEmployeeId: null,
                ToVehicleSeyirDriverFullName: null,
                ToVehicleSeyirDriverId: null,
                ToVehicleSeyirDriverKey: null,
            },
            fields: [
                { key: "ProcessCode", name: "İşlem No", sortable: true },
                { key: "ProcessDateStr", name: "Tarih/Saat", sortable: true },
                { key: "TransferType", name: "Transfer Tipi", sortable: true },
                { key: "FromVehiclePlate", name: "Kaynak Araç", sortable: true },
                { key: "TargetName", name: "Hedef", sortable: true },
                { key: "FuelType", name: "Yakıt Tipi", sortable: true },
                { key: "QuantityStr", name: "Miktar (Lt)", sortable: true, tdClass: "text-right" },
                { key: "FromVehicleCurrentKM", name: "Kaynak KM", sortable: false, tdClass: "text-right" },
                { key: "FromVehicleDriverName", name: "Kaynak Sürücü", sortable: false },
                { key: "ResponsiblePerson", name: "Personel", sortable: true },
                { key: "Description", name: "Açıklama", sortable: false }
            ],
            buttons: [
                { text: "Detay", key: "view", icon: "EyeIcon", variant: "info", action: this.viewDetails },
                { text: "Düzenle", key: "edit", icon: "EditIcon", variant: "warning", action: this.editItem },
                { text: "Sil", key: "delete", icon: "TrashIcon", variant: "danger", action: this.deleteItem }
            ]
        }
    },
    mounted() {
        this.loadVehiclePlates();
        this.loadStatistics();
    },
    methods: {
        async loadVehiclePlates() {
             try {
                const response = await systemDataApi.VehiclePlate();
                if (response.data.Success) {
                    this.vehiclePlates = response.data.Data || [];
                }
            } catch (error) {
                console.error("Vehicle plates loading error", error);
            }
        },
        async loadStatistics() {
            try {
                const response = await api.DrainingFuelFromVehicle.Statistics(this.filter);
                if (response.data.Success && response.data.Data) {
                    const data = response.data.Data;
                    // Backend bazı alanları boş döndürürse "undefined lt" görünmesin diye
                    // her zaman emniyetli default'larla birleştir.
                    this.statistics = {
                        TotalTransferCount: data.TotalTransferCount || 0,
                        VehicleToVehicleCount: data.VehicleToVehicleCount || 0,
                        VehicleToStorageCount: data.VehicleToStorageCount || 0,
                        VehicleToVehicleTotalQuantity: data.VehicleToVehicleTotalQuantity || 0,
                        VehicleToVehicleTotalQuantityStr: data.VehicleToVehicleTotalQuantityStr || "0,00",
                        VehicleToStorageTotalQuantity: data.VehicleToStorageTotalQuantity || 0,
                        VehicleToStorageTotalQuantityStr: data.VehicleToStorageTotalQuantityStr || "0,00",
                        TotalQuantity: data.TotalQuantity || 0,
                        TotalQuantityStr: data.TotalQuantityStr || "0,00",
                        FuelTypeBreakdown: Array.isArray(data.FuelTypeBreakdown) ? data.FuelTypeBreakdown : [],
                    };
                }
            } catch (error) {
                console.error("Statistics loading error", error);
            }
        },
        refreshData() {
            this.$refs.table.refresh();
            this.loadStatistics();
        },
        clearFilter() {
            this.filter = {
                StartDate: null,
                EndDate: null,
                TransferType: null,
                FromVehiclePlateId: null
            };
            this.refreshData();
        },
        getFuelTypeCardStyle(idx) {
            const colors = [
                { bg: '#f8f4ff', border: '#7367f0', text: '#7367f0' },
                { bg: '#f0fff8', border: '#28c76f', text: '#28c76f' },
                { bg: '#f0fbff', border: '#00cfe8', text: '#00cfe8' },
                { bg: '#fff8f0', border: '#ff9f43', text: '#ff9f43' },
                { bg: '#fff0f0', border: '#ea5455', text: '#ea5455' },
                { bg: '#f5f0ff', border: '#9b59b6', text: '#9b59b6' },
            ];
            const c = colors[idx % colors.length];
            return `background-color:${c.bg}; border-left: 4px solid ${c.border}; color:${c.text};`;
        },
        provider(params) {
            const requestModel = {
                Skip: params.Skip,
                Take: params.Take,
                QueryParam: params.QueryParam || null,
                IsAscending: params.IsAscending || false,
                OrderColumnName: params.OrderColumnName || null,
                StartDate: this.filter.StartDate || null,
                EndDate: this.filter.EndDate || null,
                TransferType: this.filter.TransferType ?? null,
                FromVehiclePlateId: this.filter.FromVehiclePlateId || null
            };
            return api.DrainingFuelFromVehicle.Datatable(requestModel);
        },
        viewDetails(item) {
            this.selectedItem = item;
            this.$showModal("view-transfer-detail");
        },
        createNew() {
             this.editing = false;
             this.form = {
                IsFromVehicleToVehicle: true,
                FuelTypeId: null,
                Quantity: 0,
                FromVehiclePlateId: null,
                ToVehiclePlateId: null,
                ToFuelStorageId: null,
                ResponsibleEmployeeId: null,
                Description: '',
                FromVehicleCurrentKM: null,
                FromVehicleDriverEmployeeId: null,
                FromVehicleSeyirDriverFullName: null,
                FromVehicleSeyirDriverId: null,
                FromVehicleSeyirDriverKey: null,
                ToVehicleCurrentKM: null,
                ToVehicleDriverEmployeeId: null,
                ToVehicleSeyirDriverFullName: null,
                ToVehicleSeyirDriverId: null,
                ToVehicleSeyirDriverKey: null,
             };
             this.errors = {};
             this.$showModal("create-transfer-fuel");
        },
        editItem(item) {
            this.editing = true;
            this.errors = {};
            this.form = {
                Id: item.Id,
                IsFromVehicleToVehicle: item.IsFromVehicleToVehicle,
                FuelTypeId: item.FuelTypeId,
                Quantity: item.Quantity,
                FromVehiclePlateId: item.FromVehiclePlateId,
                ToVehiclePlateId: item.ToVehiclePlateId,
                ToFuelStorageId: item.ToFuelStorageId,
                ResponsibleEmployeeId: item.ResponsibleEmployeeId,
                Description: item.Description || '',
                FromVehicleCurrentKM: item.FromVehicleCurrentKM,
                FromVehicleDriverEmployeeId: item.FromVehicleDriverEmployeeId,
                FromVehicleSeyirDriverFullName: item.FromVehicleSeyirDriverFullName,
                FromVehicleSeyirDriverId: item.FromVehicleSeyirDriverId,
                FromVehicleSeyirDriverKey: item.FromVehicleSeyirDriverKey,
                ToVehicleCurrentKM: item.ToVehicleCurrentKM,
                ToVehicleDriverEmployeeId: item.ToVehicleDriverEmployeeId,
                ToVehicleSeyirDriverFullName: item.ToVehicleSeyirDriverFullName,
                ToVehicleSeyirDriverId: item.ToVehicleSeyirDriverId,
                ToVehicleSeyirDriverKey: item.ToVehicleSeyirDriverKey,
            };
            this.$showModal("create-transfer-fuel");
        },
        deleteItem(item) {
            this.$confirm(
                "Silmek istediğinize emin misiniz?",
                `${item.ProcessCode} işlem kodlu tahliye kaydı silinecek. Araçtan Depoya aktarımlarda depo bakiyesi otomatik geri alınır. Bu işlem geri alınamaz.`
            ).then((result) => {
                if (!result) return;
                api.DrainingFuelFromVehicle.Delete(item.Id)
                    .then((res) => {
                        // Backend'den gelen mesaji her durumda goster (Success ya da
                        // "Boyle bir kayit bulunamadi" gibi gercek sebep). Onceki kod
                        // sadece Success=true'da refresh ediyordu; backend "not found"
                        // dondugunde tablo bayatlamis halde kaliyordu — kullanici ayni
                        // satira tekrar tikladiginda yine ayni hatayi aliyordu.
                        // Hem basari hem bulunamadi durumlarinda tabloyu yenileyerek
                        // tutarsizligi sifirliyoruz.
                        const message = res && res.data && res.data.Message;
                        if (res && res.data && res.data.Success) {
                            this.$result(res);
                            this.refreshData();
                        } else {
                            // Success=false: backend Message'i toast olarak goster,
                            // tabloyu da yenileyerek soft-delete edilmis kayitlari listeden dusur.
                            this.$result({ data: { Success: false, Message: message || "Kayit silinemedi." } });
                            this.refreshData();
                        }
                    })
                    .catch((err) => {
                        // 5xx gibi durumlarda backend body'sinden gercek mesaji cikar.
                        const backendMsg = err && err.response && err.response.data
                            && (err.response.data.Message || (typeof err.response.data === "string" ? err.response.data : null));
                        if (backendMsg) {
                            this.$result({ data: { Success: false, Message: backendMsg } });
                        } else {
                            this.$result(null, err);
                        }
                    });
            });
        },
        save() {
            // Sunucuya gönderilmeden önce frontend tarafında zorunlu alan kontrolü.
            // Eksik alan varsa kullanıcı anlamsız "Bilinmeyen bir hata oluştu" mesajı
            // yerine direkt hangi alanın eksik olduğunu görür.
            if (!this.validateForm()) return;

            if (this.editing) {
                this.update();
            } else {
                this.create();
            }
        },
        validateForm() {
            const f = this.form;
            const missing = [];
            if (f.IsFromVehicleToVehicle === null || f.IsFromVehicleToVehicle === undefined) missing.push("Transfer Tipi");
            if (!f.FuelTypeId) missing.push("Yakıt Tipi");
            if (!f.Quantity || Number(f.Quantity) <= 0) missing.push("Transfer Miktarı");
            if (!f.FromVehiclePlateId) missing.push("Kaynak Araç Plakası");
            if (f.IsFromVehicleToVehicle && !f.ToVehiclePlateId) missing.push("Hedef Araç Plakası");
            if (!f.IsFromVehicleToVehicle && !f.ToFuelStorageId) missing.push("Hedef Depo");
            if (!f.ResponsibleEmployeeId) missing.push("Transfer Eden Personel");

            if (missing.length > 0) {
                this.$result(null, { response: { data: "Zorunlu alanları doldurunuz: " + missing.join(", ") } });
                return false;
            }
            return true;
        },
        create() {
            this.loading = true;
            const payload = { ...this.form };

            api.DrainingFuelFromVehicle.Create(payload)
                .then((res) => {
                    if (res.data.Success) {
                        this.refreshData();
                        this.$hideModal("create-transfer-fuel");
                    }
                    // Success ya da Success=false her durumda backend mesajını göster.
                    this.$result(res);
                    this.loading = false;
                })
                .catch((err) => {
                    // 500 gibi cevaplarda da gerçek sebebi görebilmek için body'den mesaj çıkarmaya çalış.
                    const backendMsg = err && err.response && err.response.data
                        && (err.response.data.Message || (typeof err.response.data === "string" ? err.response.data : null));
                    if (backendMsg) {
                        this.$result({ data: { Success: false, Message: backendMsg } });
                    } else {
                        this.$result(null, err);
                    }
                    if (err.response && err.response.data && err.response.data.Errors) {
                        this.errors = err.response.data.Errors;
                    }
                    this.loading = false;
                });
        },
        update() {
            this.loading = true;
            const payload = { ...this.form };

            api.DrainingFuelFromVehicle.Update(payload)
                .then((res) => {
                    if (res.data.Success) {
                        this.refreshData();
                        this.$hideModal("create-transfer-fuel");
                    }
                    this.$result(res);
                    this.loading = false;
                })
                .catch((err) => {
                    const backendMsg = err && err.response && err.response.data
                        && (err.response.data.Message || (typeof err.response.data === "string" ? err.response.data : null));
                    if (backendMsg) {
                        this.$result({ data: { Success: false, Message: backendMsg } });
                    } else {
                        this.$result(null, err);
                    }
                    if (err.response && err.response.data && err.response.data.Errors) {
                        this.errors = err.response.data.Errors;
                    }
                    this.loading = false;
                });
        }
    }
}
</script>
